module.exports = __webpack_public_path__ + "static/media/partnerAdvantage.557d04e4.svg";